import React, { useEffect, Fragment } from 'react';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import MessageIcon from '@material-ui/icons/QuestionAnswer';
import NoteIcon from '@material-ui/icons/Note';
import TaskIcon from '@material-ui/icons/Assignment';
import MeetingIcon from '@material-ui/icons/Event';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';



const useStyles = makeStyles((theme) => ({
    draggableIcon: {
        width: 50,
        height: 50,
        borderRadius: '50%',
        backgroundColor: theme.palette.secondary.main,
        color: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        boxShadow: theme.shadows[3],
        zIndex:100000
    }
}));

function Draft_button(props){

    const classes = useStyles(props);

    if(props.drafts[props.company_id]==undefined){
        return(null);
    }
    let drafts = props.drafts[props.company_id];
    

    return(
        <Fragment>
            {
    Object.keys(drafts).sort().map(function(draft_type, index){
        let icon = undefined;
        let handleClick = undefined;
        if (draft_type == 'NOTE') { icon = <NoteIcon style={{fontSize:undefined}} />; handleClick = props.setNote; }
        else if (draft_type == 'EMAIL') { icon = <EmailIcon  style={{fontSize:undefined}}/>; handleClick = props.setEmail; }
        else if (draft_type == 'PHONE_CALL') { icon = <PhoneIcon style={{fontSize:undefined}} />; handleClick = props.setPhoneCall; }
        else if (draft_type == 'TASK') { icon = <TaskIcon  style={{fontSize:undefined}}/>; handleClick = props.setTask; }
        else if (draft_type == 'MEETING') { icon = <MeetingIcon  style={{fontSize:undefined}}/>; handleClick = props.setMeeting; }
        else if (draft_type == 'MESSAGE') { icon = <MessageIcon  style={{fontSize:undefined}}/>; handleClick = props.setMessage; }
        return (
            <div className={classes.draggableIcon} style={{
                position: 'fixed', // Ensures it's on the screen
                bottom: (index + 1) * 60+50 + 'px',
                right: '10px',
            }} onClick={() => { handleClick(JSON.parse(JSON.stringify(drafts[draft_type]))); }}>
                {icon}
                <Tooltip title="Remove draft">
                    <IconButton
                        size="small"
                        style={{
                            backgroundColor:'white',
                            position: 'absolute',
                            top: '-2px',
                            right: '-2px',
                            zIndex: 1, // Ensure it’s on top of the icon
                        }}
                        onClick={(e) => {
                            e.stopPropagation(); // Prevent click from triggering handleClick
                            props.deleteDraft({company_id:props.company_id, draft_type:draft_type});
                        }}
                    >
                        <CloseIcon style={{fontSize:'10px'}} />
                    </IconButton>
                </Tooltip>
            </div>
        );
    })}
    </Fragment>
    )
    
}



export default connect(ss,dd)(Draft_button);


function ss(state){
    return{
        rerender:state.operational_states.drafts.rerender,
        drafts:state.operational_states.drafts.companies
    }
}

function dd(dispatch) {
    return {
        deleteDraft: (val) => { dispatch({ type: 'STATE_DELETE_DRAFTS', val: val }) }
    }
}